/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinksByExpirationRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinksByExpiration.pb'
import {GetInstrumentLinksByExpirationResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLinksByExpiration.pb'


export const getInstrumentLinksByExpiration = (request:GetInstrumentLinksByExpirationRequest, options?: CashRequestOptions) => post<GetInstrumentLinksByExpirationRequest, GetInstrumentLinksByExpirationResponse>("/2.0/cash/get-instrument-links-by-expiration", request, {...options, rejectOnError: true })